<template>
  <div id="verifyAccount">
    <div class="container bg-body">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
          <div class="text-center mt-5">
            <h4 class="text-muted" v-if="errors">
              {{ errors }}
            </h4>
            <!-- <button @click="fnVerifyAccount()" class="btn btn-info mt-3">
              Verify
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as authService from '../../../services/auth.service'
import * as messageService from '../../../services/message.service'
export default {
  data() {
    return {
      code: this.$route.params.code,
      errors: ''
    }
  },
  methods: {
    fnVerifyAccount: async function () {
      try {
        console.log(this.code)

        const response = await authService.accountVerification(this.code)
        this.errors = {}

        if (response.data.status_code === 200) {
          this.$router.push({
            name: 'auth.resetPassword',
            params: { token: this.code }
          })
        } else {
          this.$router.push({ name: 'auth.sign-in' })
        }
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Account verification',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Account verification',
              error.response.data.message
            )
            break
          case 500:
            this.errors = error.response.data.message
            messageService.fnSweetAlertErrorToast(
              'Account verification',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Account verification',
              'Something wrong, please try again!'
            )
            break
        }
      }
    }
  },
  mounted() {
    this.fnVerifyAccount()
  }
}
</script>
